import React, { useState } from "react";
import { FaMicrophone, FaMicrophoneSlash } from "react-icons/fa";
import * as webRTCHandler from "../../utils/webRTCHandler";

const MicButton = () => {
  const [isMicMuted, setIsMicMuted] = useState(false);

  const handleMicButtonPressed = () => {
    webRTCHandler.toggleMic(!isMicMuted);
    setIsMicMuted(!isMicMuted);
  };

  return (
    <div className="video_button_container" onClick={handleMicButtonPressed}>
      {isMicMuted ? (
        <FaMicrophoneSlash className="video_button_icon active" />
      ) : (
        <FaMicrophone className="video_button_icon" />
      )}
    </div>
  );
};

export default MicButton;
